import groupBy from 'lodash/groupBy'
import orderBy from 'lodash/orderBy'

import { server } from '@/services/'

const state = {
  isFetching: false,
  cleaningLogs: [],
  stations: [],
  zones: [],
  carInStations: [],
  cars: [],
  cleaners: []
}

const mutations = {
  setIsFetching (state, payload) {
    state.isFetching = payload
  },
  setCleaningLogs (state, payload) {
    state.cleaningLogs = payload
  },
  setZones (state, payload) {
    state.zones = payload
  },
  setStations (state, payload) {
    state.stations = payload
  },
  setCars (state, payload) {
    state.cars = payload
  },
  setCarInStations (state, payload) {
    state.carInStations = payload
  },
  setJoinedData (state, payload) {
    state.joinedData = payload
  },
  setCleaners (state, payload) {
    state.cleaners = payload
  },
  toggleZone (state, payload) {
    state.zones[payload.idx].COLLAPSED = !state.zones[payload.idx].COLLAPSED
  },
  toggleStation (state, payload) {
    let idx = state.stations.findIndex(station => station.CODE === payload)
    state.stations[idx].COLLAPSED = !state.stations[idx].COLLAPSED
  },
  toggleCar (state, payload) {
    let idx = state.carInStations.findIndex(cist => cist.CODE === payload)
    state.carInStations[idx].COLLAPSED = !state.carInStations[idx].COLLAPSED
  }
}

const actions = {
  fetchCleaningLogs ({commit}) {
    return new Promise((resolve, reject) => {
      server.get('/ops/getCleaningLogs').then(
        resp => {
          commit('setCleaningLogs', resp.data.msgContent.data)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchZones ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getZones').then(
        resp => {
          let zones = resp.data.msgContent.data.map(zone => ({...zone, COLLAPSED: false}))
          commit('setZones', zones)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchStations ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getStations').then(
        resp => {
          let stations = resp.data.msgContent.data.map(station => ({...station, COLLAPSED: false}))
          commit('setStations', stations)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCars ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCars').then(
        resp => {
          commit('setCars', resp.data.msgContent.data)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCarInStations ({commit}) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCarInStations').then(
        resp => {
          let carInStations = resp.data.msgContent.data.map(cist => ({...cist, COLLAPSED: false}))
          commit('setCarInStations', carInStations)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  fetchCleaners({commit}) {
    return new Promise((resolve, reject) => {
      server.get('/sso/getUA_Cleaners').then(
        resp => {
          commit('setCleaners', resp.data.msgContent.data)
          resolve()
        },
        err => reject(err)
      )
    })
  },
  composeLogsData({ commit, state }) {
    let cistLogs = state.carInStations.map(cist => ({
      ...cist,
      LOGS: state.cleaningLogs.filter(log => log.CAR_IN_STATION_CODE === cist.CODE)
    }))
    let cistLogsCar = cistLogs.map(cist => ({
      ...cist,
      CAR_DETAIL: state.cars.find(car => car.CODE === cist.CAR_CODE) || {}
    }))
    // calculate average car rating
    let logGrouped = groupBy(state.cleaningLogs, log => log.CAR_IN_STATION_CODE)
    cistLogsCar.forEach(cist => {
      if (logGrouped[cist.CODE]) {
        let ratings = logGrouped[cist.CODE].map(obj => obj.CLEANING_RATE_RATING)
        if (ratings.length) {
          let average = parseFloat(ratings.reduce( ( p, c ) => p + c, 0 ) / ratings.length)
          Object.assign(cist, { AVERAGE_RATING: average })
        } else {
          Object.assign(cist, { AVERAGE_RATING: 0 })
        }
      } else {
        // no logs
        Object.assign(cist, { AVERAGE_RATING: 0 })
      }
    })
    commit('setCarInStations', cistLogsCar)
  }

}

const getters = {
  getStationsByZone: (state) => (zoneCode) => {
    return orderBy(state.stations.filter(station => station.ZONE_CODE === zoneCode), 'NAME')
  },
  getCistByStation: (state) => (stationCode) => {
    return state.carInStations.filter(cist => cist.STATION_CODE === stationCode)
  },
  getCleanerByCode: (state) => (cleanerCode) => {
    return state.cleaners.find(cleaner => cleaner.CODE === cleanerCode)
  },
  getAvgRateStation: (state) => (stationCode) => {
    let filteredCist = state.carInStations.filter(cist => cist.STATION_CODE === stationCode && cist.AVERAGE_RATING > 0)
    if (filteredCist.length > 0) {
      let ratings = filteredCist.map(obj => obj.AVERAGE_RATING)
      let average = parseFloat(ratings.reduce( ( p, c ) => p + c, 0 ) / ratings.length)
      return average
    } else {
      return 0
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
